@if(breakpointService.isDesktop()) {
  <ng-container [ngTemplateOutlet]="desktopTemplate"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="mobileTemplate"></ng-container>
}

<ng-template #mobileTemplate>
  <div class="mobile-dialog occasion-genius-dialog">
    <div class="mobile-dialog__header">
      <h2 class="mobile-dialog__header--title">
        Add destination / City
      </h2>
    </div>
    <div class="mobile-dialog__content">
      <div class="mobile-dialog__content--search">
        <input [formControl]="searchForm"
               [matAutocomplete]="auto"
               class="dialog__input"
               placeholder="Type destination/city name"
               #inputSearchRef
        />
        @if(inputSearchRef.value) {
          <button class="dialog__input-reset btn-default" (click)="resetDestinationHandler(inputSearchRef);">
            <mat-icon class="reset-icon" [svgIcon]="eSvgIcons.RESET"></mat-icon>
          </button>
        }
        <mat-autocomplete #auto="matAutocomplete">
          @for (option of filteredOptions; track $index) {
            <mat-option [value]="option.label" (click)="selectedDestinationHandler(option)">
              {{ option.label }}
            </mat-option>
          }
        </mat-autocomplete>
      </div>

      <div class="mobile-dialog__content--duration">
        <div class="nights-box">
          <button mat-ripple [disabled]="daysInDestination <= 1">
            <mat-icon
              [svgIcon]="eSvgIcons.IC_MINUS"
              (click)="toggleDaysDurationChanges(-1)"
            ></mat-icon>
          </button>
          <span><b>{{ daysInDestination }}</b> days</span>
          <button mat-ripple [disabled]="daysInDestination >= 10">
            <mat-icon
              [svgIcon]="eSvgIcons.IC_PLUS"
              (click)="toggleDaysDurationChanges(1)"
            ></mat-icon>
          </button>
        </div>
      </div>

      <div class="mobile-dialog__content--details">
        <p class="mobile-dialog__content--normal">
          Routeperfect’s experts will add this destination at the best place on your route. Prefer a different location? Drag it to the location of your choice
        </p>
      </div>

      @if (data.isOptimizedMode) {
        <div class="mobile-dialog__content--optimized">
          <mat-checkbox [(ngModel)]="maintainDuration">
            <span class="mobile-dialog__content--checkbox-label">Maintain current duration. change itinerary accordingly</span>
          </mat-checkbox>
        </div>
      }

      @if (!maintainDuration) {
        <p class="mobile-dialog__content--warning">
          <span>Your trip will be extended by {{daysInDestination}} day</span>
          @if (data.isSpecifyDates) {
            <span>New return date: {{ newTripEndDate }}</span>
          }
        </p>
      }
    </div>
    <div class="mobile-dialog__footer">
      <button class="btn-default btn-gray" (click)="closeModal({res: false, maintain: false, destination: null})">
        Cancel
      </button>
      <button class="btn-default btn-blue" (click)="submitBtnHandler()" [disabled]="!selectedOption">
        Add destination
      </button>
    </div>
  </div>
</ng-template>

<ng-template #desktopTemplate>
  <div class="dialog">
    <h2 class="dialog__title">Add destination / City</h2>

    <div class="dialog__input-group">
      <input [formControl]="searchForm"
             [matAutocomplete]="auto"
             class="dialog__input"
             placeholder="Type destination/city name"
      />
      <mat-autocomplete #auto="matAutocomplete">
        @for (option of filteredOptions; track $index) {
          <mat-option [value]="option.label" (click)="selectedDestinationHandler(option)">
            {{ option.label }}
          </mat-option>
        }
      </mat-autocomplete>
    </div>

    <div class="dialog__duration">
      <div class="nights-box">
        <button mat-ripple [disabled]="daysInDestination <= 1">
          <mat-icon
            [svgIcon]="eSvgIcons.IC_MINUS"
            (click)="toggleDaysDurationChanges(-1)"
          ></mat-icon>
        </button>
        <span><b>{{ daysInDestination }}</b> days</span>
        <button mat-ripple [disabled]="daysInDestination >= 10">
          <mat-icon
            [svgIcon]="eSvgIcons.IC_PLUS"
            (click)="toggleDaysDurationChanges(1)"
          ></mat-icon>
        </button>
      </div>
    </div>

    <p class="dialog__description">
      Routeperfect’s experts will add this destination at the best place on your
      route. Prefer a different location? Drag it to the location of your choice.
    </p>

    @if (data.isOptimizedMode) {
      <div class="dialog__checkbox">
        <mat-checkbox [(ngModel)]="maintainDuration">
          <span>Maintain current duration. change itinerary accordingly</span>
        </mat-checkbox>
      </div>
    }

    @if (!maintainDuration) {
      <p class="dialog__trip-info">
        <span>Your trip will be extended by {{daysInDestination}} day</span>
        @if (data.isSpecifyDates) {
          <span>New return date: {{ newTripEndDate }}</span>
        }
      </p>
    }

    <div class="dialog__actions">
      <button
        class="dialog__button dialog__button--cancel"
        (click)="closeModal({res: false, maintain: false, destination: null})"
      >
        Cancel
      </button>
      <button class="dialog__button dialog__button--add" (click)="submitBtnHandler()" [disabled]="!selectedOption">
        Add destination
      </button>
    </div>
  </div>
</ng-template>
